// Tabulka Economic calendar: filtry den / měna / dopad / hledání nad daty týdne
// (json_script). Měnu a dopad si prohlížeč pamatuje mezi týdny.
import { gettext, LOCALE } from './i18n.js';
const KEY = 'mx_calendar_filters';
const pad = (n) => String(n).padStart(2, '0');
const localDay = (t) => { const d = new Date(t); return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; };

function saved() {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
}

export function calendarTable(dataId) {
  const data = JSON.parse(document.getElementById(dataId).textContent);
  const keep = saved();
  return {
    data,
    zone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
    f: { day: 'all', ccy: data.currencies.includes(keep.ccy) ? keep.ccy : 'all', imp: keep.imp || 'all', q: '' },
    now: Date.now(),

    init() {
      this.$watch('f', (v) => { try { localStorage.setItem(KEY, JSON.stringify({ ccy: v.ccy, imp: v.imp })); } catch { /* bez úložiště */ } }, { deep: true });
      setInterval(() => { this.now = Date.now(); }, 60e3);
    },
    get days() {
      const seen = new Map();
      for (const e of data.events) {
        const k = localDay(e.t);
        if (!seen.has(k)) seen.set(k, new Date(e.t).toLocaleDateString(LOCALE, { weekday: 'long', month: 'short', day: 'numeric' }));
      }
      return [...seen.entries()];
    },
    get list() {
      const q = this.f.q.trim().toLowerCase();
      return data.events.filter((e) => (this.f.day === 'all' || localDay(e.t) === this.f.day)
        && (this.f.ccy === 'all' || e.ccy === this.f.ccy)
        && (this.f.imp === 'all' || (this.f.imp === 'high' ? e.imp === 'high' || e.imp === 'week' : e.imp === this.f.imp))
        && (!q || e.name.toLowerCase().includes(q)));
    },
    get nextId() { return data.events.find((e) => e.t >= this.now)?.id; },
    get filtered() { return this.f.day !== 'all' || this.f.ccy !== 'all' || this.f.imp !== 'all' || this.f.q.trim() !== ''; },
    reset() { this.f = { day: 'all', ccy: 'all', imp: 'all', q: '' }; },
    when(t) { return new Date(t).toLocaleString(LOCALE, { weekday: 'short', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }); },
    badge(imp) { return imp === 'week' || imp === 'high' ? 'neg' : imp === 'medium' ? 'warn' : ''; },
    impLabel(imp) { return imp === 'week' ? gettext('High · event of the week') : data.impactLabels[imp]; },
  };
}
